export const SUPABASE_ORGANIZATION = "organizations_metadata"
export const SUPABASE_ENDPOINTS = "endpoints"
export const INTEGRATIONS = "integrations"
